/**
 * Some Hustlance user profiles store their avatar as a raw base64 data: URI
 * (from the main app's profile upload flow) rather than a hosted image URL.
 * Embedding that directly into a Firestore document balloons its size —
 * a single avatar can be 300KB+ as text, versus Firestore's 1MB per-document
 * limit — and it's pure waste since post/comment cards never render an
 * author avatar image to begin with. Only ever persist real http(s) URLs.
 */
export function safeAvatarUrl(url: string | undefined): string | undefined {
  return url && /^https?:\/\//.test(url) ? url : undefined;
}
